import _ from 'lodash';

const initialState = {
  showModal: false,
  showNoticeModal: false,
  selectedWorkstreams: [],
  selectedDocuments: [],
  onSearchWorkstream: null,
  tagWorkstreamApi: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'TAG_FILE_WORKSTRTEAM_TOGGLE_MODAL_DISPLAY': {
      return {
        ...state,
        showModal: action.showModal,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_TOGGLE_NOTICE_MODAL_DISPLAY': {
      return {
        ...state,
        showNoticeModal: action.showNoticeModal,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_SET_SELECTED_DOCUMENTS': {
      return {
        ...state,
        selectedDocuments: action.selectedDocuments,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_SET_SELECTED_WORKSTREAMS': {
      return {
        ...state,
        selectedWorkstreams: action.selectedWorkstreams,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_SET_TAG_WORKSTREAM_API': {
      return {
        ...state,
        tagWorkstreamApi: action.tagWorkstreamApi,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_INITIALIZE': {
      return {
        ...state,
        selectedDocuments: action.selectedDocuments,
        selectedWorkstreams: action.selectedWorkstreams,
        tagWorkstreamApi: action.tagWorkstreamApi,
        onSearchWorkstream: action.onSearchWorkstream,
      };
    }

    case 'TAG_FILE_WORKSTRTEAM_RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
